import { HoverPopover } from "./Popover"

export const PoweredByAuroraLabel = () => {
  return (
    <HoverPopover
      trigger={
        <div className="flex items-center py-1 px-2 rounded-full bg-[#E1F9EA]">
          <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Powered by Aurora"
            aria-hidden="true"
          >
            <path
              d="M5 0.97567C5.4025 0.97567 5.76428 1.19928 5.94424 1.55919L8.91297 7.49659C9.07775 7.82615 9.06045 8.21001 8.86692 8.5236C8.67312 8.83719 8.33743 9.02433 7.969 9.02433H2.03126C1.66283 9.02433 1.32715 8.83719 1.13335 8.5236C0.93955 8.21001 0.922246 7.82615 1.08703 7.49659L4.05576 1.55919C4.23572 1.19928 4.5975 0.97567 5 0.97567ZM5 0.25C4.32517 0.25 3.70863 0.631203 3.40675 1.23469L0.438016 7.17209C0.16196 7.72419 0.191509 8.38012 0.516015 8.90507C0.840521 9.43029 1.41393 9.75 2.03126 9.75H7.96874C8.58607 9.75 9.15948 9.43029 9.48399 8.90507C9.80849 8.37985 9.83804 7.72419 9.56198 7.17209L6.59325 1.23469C6.29164 0.631203 5.67483 0.25 5 0.25Z"
              fill="#17A615"
              stroke="#17A615"
              strokeWidth="0.5"
            />
          </svg>
        </div>
      }
    >
      Powered by Aurora
    </HoverPopover>
  )
}
